const validate = value => {
  if (value.toString().length !== 18) {
    return false
  }

  var barcode = value.substring(0, value.length - 1)
  var checksum = parseInt(value.substring(value.length - 1), 10)
  var calcSum = 0
  var calcChecksum = 0
  barcode.split('').map(function(number, index) {
    number = parseInt(number, 10)
    if (value.length % 2 === 0) {
      index += 1
    }
    if (index % 2 === 0) {
      calcSum += number
    } else {
      calcSum += number * 3
    }
  })

  calcSum %= 10
  calcChecksum = calcSum === 0 ? 0 : 10 - calcSum
  if (calcChecksum !== checksum) {
    return false
  }

  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return `${field} is incorrect`
  }
}
